import { API_BASE_URL } from '../config';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// Estructura real de cada manzana (fila frente a una calle, columnas internas
// espalda con espalda, fila frente a la otra calle), verificada contra el plano
// original de mensura. Solo estan cargadas las fracciones ya digitalizadas.
const LAYOUTS = {
    2: { // Villa Che Jazmín
        nombreCorto: 'Villa Che Jazmín',
        planoPdf: '/planos/villa-che-jazmin.pdf',
        zonas: [
            {
                titulo: 'Zona norte · entre Calle 01 y Calle 04',
                calleTop: 'Calle 01',
                filas: [
                    { calle: null, manzanas: [10, 1] },
                    { calle: 'Calle 02 (oeste) · Calle 03, en curva (este)', manzanas: [9, 2] }
                ]
            },
            {
                titulo: 'Zona sur · de Calle 04 al límite del loteamiento',
                calleTop: 'Calle 04',
                filas: [
                    { calle: null, manzanas: [8, 3] },
                    { calle: 'Calle 05 (oeste) · Calle 06 (este)', manzanas: [7, 4] },
                    { calle: 'Calle 07 (oeste) · Calle 08 (este)', manzanas: [6, 5] }
                ]
            }
        ],
        manzanas: {
            1: { calles: 'Calle 01 (N) · Calle 03, en curva (S) · Calle 14 (E)', secciones: [ { tipo: 'fila', lotes: [13, 14, 1] }, { tipo: 'columnas', oeste: [12, 11, 10, 9, 8, 7], este: [2, 3, 4, 5, 6] } ] },
            2: { calles: 'Calle 03 (N) · Calle 04 (S) · junto a Plaza y EDP', secciones: [ { tipo: 'columna', lotes: [3, 4, 5, 6] } ] },
            3: { calles: 'Calle 04 (N) · Calle 05/06 (S) · Calle 09 (E)', secciones: [ { tipo: 'fila', lotes: [18, 19, 20, 1] }, { tipo: 'columnas', oeste: [17, 16, 15, 14, 13, 12], este: [2, 3, 4, 5, 6, 7] }, { tipo: 'fila', lotes: [11, 10, 9, 8] } ] },
            4: { calles: 'Calle 05/06 (N) · Calle 07/08 (S) · Calle 09/10 (E)', secciones: [ { tipo: 'fila', lotes: [16, 17, 1] }, { tipo: 'columnas', oeste: [15, 14, 13, 12, 11], este: [2, 3, 4, 5, 6] }, { tipo: 'fila', lotes: [10, 9, 8, 7] } ] },
            5: { calles: 'Calle 07/08 (N) · límite sur · Calle 09 (E)', secciones: [ { tipo: 'fila', lotes: [6, 7, 8, 9, 1] }, { tipo: 'fila', lotes: [5, 4, 3, 2] } ] },
            6: { calles: 'Calle 07/08 (N) · límite sur · Calle 11 (O)', secciones: [ { tipo: 'fila', lotes: [6, 7, 8, 9, 1] }, { tipo: 'fila', lotes: [5, 4, 3, 2] } ] },
            7: { calles: 'Calle 05/06 (N) · Calle 07/08 (S) · Calle 11 (O)', secciones: [ { tipo: 'fila', lotes: [18, 19, 20, 1] }, { tipo: 'columnas', oeste: [17, 16, 15, 14, 13, 12], este: [2, 3, 4, 5, 6, 7] }, { tipo: 'fila', lotes: [11, 10, 9, 8] } ] },
            8: { calles: 'Calle 04 (N) · Calle 05/06 (S) · Calle 11 (O)', secciones: [ { tipo: 'fila', lotes: [20, 21, 1] }, { tipo: 'columnas', oeste: [19, 18, 17, 16, 15, 14, 13], este: [2, 3, 4, 5, 6, 7, 8] }, { tipo: 'fila', lotes: [12, 11, 10, 9] } ] },
            9: { calles: 'Calle 02 (N) · Calle 04 (S) · junto a FPA 02', secciones: [ { tipo: 'fila', lotes: [17, 18, 19, 1] }, { tipo: 'columnas', oeste: [16, 15, 14, 13, 12, 11, 10], este: [2, 3, 4, 5, 6, 7, 8, 9] } ] },
            10: { calles: 'Calle 01 (N) · Calle 02 (S) · Calle 12 (O)', secciones: [ { tipo: 'fila', lotes: [16, 17, 1] }, { tipo: 'columnas', oeste: [15, 14, 13, 12, 11], este: [2, 3, 4, 5, 6] }, { tipo: 'fila', lotes: [10, 9, 8, 7] } ] }
        }
    }
};

export const FRACCIONES_CON_PLANO = Object.keys(LAYOUTS).map(Number);

const ESTADO_ESTILO = {
    DISPONIBLE: { bg: 'bg-emerald-600', label: 'Disponible' },
    BLOQUEADO: { bg: 'bg-amber-600', label: 'Reservado' },
    VENDIDO: { bg: 'bg-[#4a80b3]', label: 'Vendido' }
};

function fmtGs(n) {
    return '₲ ' + Math.round(n).toLocaleString('es-PY');
}
function fmtM2(n) {
    return Number(n).toLocaleString('es-PY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m²';
}

function Celda({ lote, onSeleccionar, vertical }) {
    if (!lote) return null;
    const estilo = ESTADO_ESTILO[lote.estado_lote] || { bg: 'bg-gray-400', label: lote.estado_lote };
    const grow = Math.max(1, Math.round(Number(lote.dimension_lote)));
    return (
        <button
            onClick={() => onSeleccionar(lote)}
            className={`${estilo.bg} text-white text-xs font-semibold flex items-center justify-center border border-white/40 active:opacity-80`}
            style={vertical
                ? { flexGrow: grow, minHeight: 34, width: '100%' }
                : { flexGrow: grow, minWidth: 44, height: 46 }}
        >
            {lote.numero_lote}
        </button>
    );
}

function ManzanaCard({ numero, layout, lotesPorNumero, onSeleccionar }) {
    if (!layout) return null;
    const lotes = Object.values(lotesPorNumero);
    const supTotal = lotes.reduce((s, l) => s + Number(l.dimension_lote), 0);

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <div className="bg-emerald-50 px-3 py-2 border-b border-gray-200">
                <div className="flex justify-between items-baseline">
                    <span className="font-bold text-gray-800">Manzana {numero}</span>
                    <span className="text-[11px] text-gray-500">{lotes.length} lotes · {fmtM2(supTotal)}</span>
                </div>
                <div className="text-[11px] text-gray-600 mt-0.5">{layout.calles}</div>
            </div>
            <div>
                {layout.secciones.map((sec, i) => {
                    if (sec.tipo === 'fila') {
                        return (
                            <div key={i} className="flex">
                                {sec.lotes.map(n => <Celda key={n} lote={lotesPorNumero[n]} onSeleccionar={onSeleccionar} />)}
                            </div>
                        );
                    }
                    if (sec.tipo === 'columna') {
                        return (
                            <div key={i} className="flex flex-col">
                                {sec.lotes.map(n => <Celda key={n} lote={lotesPorNumero[n]} onSeleccionar={onSeleccionar} vertical />)}
                            </div>
                        );
                    }
                    // columnas (oeste | este)
                    return (
                        <div key={i} className="flex">
                            <div className="flex-1 flex flex-col border-r-2 border-gray-100">
                                {sec.oeste.map(n => <Celda key={n} lote={lotesPorNumero[n]} onSeleccionar={onSeleccionar} vertical />)}
                            </div>
                            <div className="flex-1 flex flex-col">
                                {sec.este.map(n => <Celda key={n} lote={lotesPorNumero[n]} onSeleccionar={onSeleccionar} vertical />)}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default function PlanoInteractivo() {
    const navigate = useNavigate();
    const { fraccionId } = useParams();
    const [lotes, setLotes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [seleccionado, setSeleccionado] = useState(null);
    const [filtroDisponibles, setFiltroDisponibles] = useState(false);

    const config = LAYOUTS[fraccionId];

    useEffect(() => {
        const fetchPlano = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/plano/${fraccionId}`);
                if (!response.ok) throw new Error('Error al obtener el plano');
                const data = await response.json();
                setLotes(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        if (config) fetchPlano();
        else setLoading(false);
    }, [fraccionId, config]);

    if (loading) {
        return <div className="flex justify-center items-center h-64"><div className="text-xl text-gray-600">Cargando plano...</div></div>;
    }

    if (!config) {
        return (
            <div className="bg-white rounded-lg shadow-md p-6 text-center space-y-4">
                <div className="text-gray-700">El plano interactivo detallado todavía no está disponible para este proyecto.</div>
                <button
                    onClick={() => navigate(`/manzanas/${fraccionId}`)}
                    className="px-4 py-2 bg-[#2f62ab] text-white rounded-lg hover:bg-blue-800"
                >
                    Ver por manzana
                </button>
            </div>
        );
    }

    if (error) {
        return <div className="bg-red-50 p-4 rounded-lg"><div className="text-red-700">Error: {error}</div></div>;
    }

    const porManzana = {};
    lotes.forEach(l => {
        const m = Number(l.numero_manzana);
        if (!porManzana[m]) porManzana[m] = {};
        porManzana[m][Number(l.numero_lote)] = l;
    });

    const totales = { DISPONIBLE: 0, BLOQUEADO: 0, VENDIDO: 0 };
    lotes.forEach(l => { totales[l.estado_lote] = (totales[l.estado_lote] || 0) + 1; });

    return (
        <div className="space-y-4 pb-10">
            <div className="flex items-center justify-between">
                <div>
                    <h2 className="text-2xl font-bold text-gray-800">Plano interactivo</h2>
                    <div className="flex items-center gap-3">
                        <p className="text-sm text-gray-600">{config.nombreCorto}</p>
                        {config.planoPdf && (
                            <a
                                href={config.planoPdf}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-1 text-sm text-blue-700 hover:text-blue-900 hover:underline"
                            >
                                📄 Ver plano original (PDF)
                            </a>
                        )}
                    </div>
                </div>
                <button onClick={() => navigate('/')} className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200">
                    Volver
                </button>
            </div>

            <div className="grid grid-cols-4 gap-2 text-center">
                <div className="bg-white rounded-lg shadow-sm p-3">
                    <div className="text-xl font-bold text-gray-800">{lotes.length}</div>
                    <div className="text-[11px] text-gray-500">Total</div>
                </div>
                <div className="bg-white rounded-lg shadow-sm p-3">
                    <div className="text-xl font-bold text-emerald-600">{totales.DISPONIBLE || 0}</div>
                    <div className="text-[11px] text-gray-500">Disponibles</div>
                </div>
                <div className="bg-white rounded-lg shadow-sm p-3">
                    <div className="text-xl font-bold text-amber-600">{totales.BLOQUEADO || 0}</div>
                    <div className="text-[11px] text-gray-500">Reservados</div>
                </div>
                <div className="bg-white rounded-lg shadow-sm p-3">
                    <div className="text-xl font-bold text-[#4a80b3]">{totales.VENDIDO || 0}</div>
                    <div className="text-[11px] text-gray-500">Vendidos</div>
                </div>
            </div>

            <div className="flex items-center justify-between">
                <div className="flex gap-3 text-xs text-gray-600">
                    <span className="flex items-center gap-1"><i className="w-3 h-3 rounded bg-emerald-600 inline-block" />Disponible</span>
                    <span className="flex items-center gap-1"><i className="w-3 h-3 rounded bg-amber-600 inline-block" />Reservado</span>
                    <span className="flex items-center gap-1"><i className="w-3 h-3 rounded bg-[#4a80b3] inline-block" />Vendido</span>
                </div>
                <button
                    onClick={() => setFiltroDisponibles(v => !v)}
                    className={`px-3 py-1.5 text-xs rounded-full border ${filtroDisponibles ? 'bg-gray-800 text-white border-gray-800' : 'bg-white text-gray-600 border-gray-300'}`}
                >
                    Solo disponibles
                </button>
            </div>

            {config.zonas.map((zona, zi) => (
                <div key={zi} className="space-y-3">
                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 border-b pb-1">{zona.titulo}</p>
                    {zona.filas.map((fila, fi) => (
                        <div key={fi}>
                            {fila.calle && <p className="text-[11px] text-center text-gray-500 my-2">— {fila.calle} —</p>}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                {fila.manzanas.map(num => (
                                    <ManzanaCard
                                        key={num}
                                        numero={num}
                                        layout={config.manzanas[num]}
                                        lotesPorNumero={filtroDisponibles
                                            ? Object.fromEntries(Object.entries(porManzana[num] || {}).filter(([, l]) => l.estado_lote === 'DISPONIBLE'))
                                            : (porManzana[num] || {})}
                                        onSeleccionar={setSeleccionado}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            ))}

            {seleccionado && (
                <div className="fixed inset-0 bg-black/30 flex items-end md:items-center justify-center z-50" onClick={() => setSeleccionado(null)}>
                    <div className="bg-white rounded-t-2xl md:rounded-2xl w-full md:w-96 p-6 space-y-4" onClick={e => e.stopPropagation()}>
                        <div>
                            <p className="text-xs text-gray-500">Manzana {seleccionado.numero_manzana}</p>
                            <h3 className="text-2xl font-bold text-gray-800">Lote {seleccionado.numero_lote}</h3>
                            <span className={`inline-block mt-1 px-2 py-0.5 rounded-full text-white text-xs ${(ESTADO_ESTILO[seleccionado.estado_lote] || {}).bg || 'bg-gray-400'}`}>
                                {(ESTADO_ESTILO[seleccionado.estado_lote] || {}).label || seleccionado.estado_lote}
                            </span>
                        </div>
                        <div className="grid grid-cols-2 gap-2 text-sm">
                            <div className="text-gray-500">Superficie</div>
                            <div className="text-right font-medium">{fmtM2(seleccionado.dimension_lote)}</div>
                            <div className="text-gray-500">Cuota mensual</div>
                            <div className="text-right font-medium">{seleccionado.cuota_lote > 0 ? fmtGs(seleccionado.cuota_lote) : 'A consultar'}</div>
                        </div>
                        {seleccionado.estado_lote === 'DISPONIBLE' ? (
                            <button
                                onClick={() => navigate(`/buscar-cliente/${seleccionado.id_lote}`)}
                                className="w-full py-3 bg-[#2f62ab] text-white rounded-lg font-semibold hover:bg-blue-800"
                            >
                                Reservar este lote
                            </button>
                        ) : (
                            <button disabled className="w-full py-3 bg-gray-200 text-gray-500 rounded-lg font-semibold cursor-not-allowed">
                                No disponible
                            </button>
                        )}
                        <button onClick={() => setSeleccionado(null)} className="w-full py-2 text-sm text-gray-500">
                            Cerrar
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
